module.exports = __webpack_public_path__ + "static/img-3-desktop-0b14f1e37765f19e8adb115dedfb2ea5.jpg";